import Div from '@/shared/Div';
import { memo, useCallback } from 'react';
import DemoItem from '@/shared/crisp/DemoItem';
import Map from '@/components/Map';
import classNames from 'classnames';
import Container from '@/shared/Container';
import withContentFlags from '@/hoc/withContentFlags';

type ExpertGuidanceDemoProps = {
  isPDP?: boolean;
  list?: any;
  title?: string;
};

const ProductDemo = (props: ExpertGuidanceDemoProps) => {
  const { isPDP, title, list } = props;

  const renderDemoOptions = useCallback((value: any, index: number) => {
    return <DemoItem key={index} data={value} isPDP={isPDP} />;
  }, []);

  if (!list) return null;

  return (
    <Div
      className={classNames('py-s6  ', {
        '!py-s9 md:py-s11 md:flex-row !bg-cs-secondary': !isPDP,
      })}
    >
      <Container
        className={classNames('!px-0 flex flex-col  gap-s6 items-center', {
          'md:flex-row': !isPDP,
        })}
      >
        {title ? (
          <Div
            className={classNames('text-h-1 md:text-hd-1', {
              'text-h-2': isPDP,
            })}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        ) : null}
        <Map
          className={classNames('flex flex-col gap-s5 ', {
            'md:gap-s6 md:flex-row': !isPDP,
          })}
          list={list}
          render={renderDemoOptions}
        />
      </Container>
    </Div>
  );
};

export default withContentFlags(memo(ProductDemo));
